import { render } from "./SpecialProgram.vue?vue&type=template&id=35c7087b&ts=true"
import script from "./SpecialProgram.vue?vue&type=script&lang=ts"
export * from "./SpecialProgram.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__